module.exports = __webpack_public_path__ + "static/media/MobileLandingConvertSpreadsheetsToAPI.a187d53f.svg";